module.exports = __webpack_public_path__ + "static/media/icon-service-modulesA2.43dd09ba.png";